<template>
  <div class="row pad-top">
    <div class="col-md-12">
      <MultiSelect
          :options="options"
          :show-labels="false"
          track-by="title"
          label="title"
          placeholder="Выбрать период"
          v-model="value"
          @select="handleChangeParse"
      >
      </MultiSelect>
    </div>
  </div>
</template>

<script>
import MultiSelect from 'vue-multiselect'

export default {
  components: {
    MultiSelect
  },
  data () {
    return {
      value: { title: 'День', value: 'day' },
      options: [
        { title: 'День', value: 'day' },
        { title: 'Неделя', value: 'week' },
        { title: 'Месяц', value: 'month' }
      ]
    }
  },
  mounted () {
  },
  methods: {
    handleChangeParse (event) {
      this.$root.$emit('handleChangeParse', event.value)
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// ParsePeriod.vue?cbef7f7a